import type { AxiosInstance } from 'axios';
import { classificarErroAdmin, type UsuarioAdmin } from '@/lib/plataforma_admin';

/**
 * O painel da pessoa no console (E175.F1, ADR-0127). // ux-neutrality:allow doc-comment
 *
 * `tem_rastro` decide o que a tela oferece: sem rastro, a pessoa pode ser // ux-neutrality:allow doc-comment
 * excluída e mudar de escritório; com rastro, só desativar. Quem decide de // ux-neutrality:allow doc-comment
 * verdade é o servidor, na escrita. // ux-neutrality:allow doc-comment
 */
export interface PessoaDetalhe extends UsuarioAdmin {
  cpf: string | null;
  responsavel_tecnico: boolean;
  senha_provisoria_pendente: boolean;
  tem_rastro: boolean;
}

/** PATCH parcial: campo ausente não mexe; nome e CPF em branco limpam. */
export interface PessoaEdicao {
  email?: string;
  display_name?: string | null;
  cpf?: string | null;
  escritorio_id?: string;
}

export async function obterPessoa(
  client: AxiosInstance,
  usuarioId: string,
): Promise<PessoaDetalhe> {
  try {
    const { data } = await client.get<PessoaDetalhe>(`/plataforma/usuarios/${usuarioId}`);
    return data;
  } catch (err) {
    throw classificarErroAdmin(err);
  }
}

export async function editarPessoa(
  client: AxiosInstance,
  usuarioId: string,
  edicao: PessoaEdicao,
): Promise<PessoaDetalhe> {
  try {
    const { data } = await client.patch<PessoaDetalhe>(`/plataforma/usuarios/${usuarioId}`, edicao);
    return data;
  } catch (err) {
    throw classificarErroAdmin(err);
  }
}

export async function definirSenhaProvisoria(
  client: AxiosInstance,
  usuarioId: string,
  senha: string,
): Promise<void> {
  try {
    await client.post(`/plataforma/usuarios/${usuarioId}/senha-provisoria`, {
      senha_provisoria: senha,
    });
  } catch (err) {
    throw classificarErroAdmin(err);
  }
}

export async function excluirPessoa(client: AxiosInstance, usuarioId: string): Promise<void> {
  try {
    await client.delete(`/plataforma/usuarios/${usuarioId}`);
  } catch (err) {
    throw classificarErroAdmin(err);
  }
}
